import { Component, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigPresorteo } from '../../../models/config-pesorteo.model';

@Component({
  selector: 'app-config-presorteo-list',
  templateUrl: './config-presorteo-list.component.html',
  styleUrls: ['./config-presorteo-list.component.scss']
})
export class ConfigPresorteoListComponent implements OnInit {

  @Input() configPresorteos: ConfigPresorteo[];

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  goToEdit(id: number): void {
    this.router.navigate(['presorteo/megaloto/config-presorteo/edit', id]);
  }

}
